import { FunctionComponent } from 'react';
import { Logo } from './Logo';
import MspLogo from './MspLogo';
import { useCanShowBrandedLogo } from './mspLogoHelper';

interface HeaderLogoProps {}

const HeaderLogo: FunctionComponent<HeaderLogoProps> = () => {
  const canShowBrandedLogo = useCanShowBrandedLogo();

  return canShowBrandedLogo ? <MspLogo className="w-44 h-[35px]" /> : <Logo className="w-44" />;
};

export default HeaderLogo;
